<template>
<div class="hris-page">
	<div class="hris-page-inner">
		<div class="hris-page-header">
			<span class="hris-page-eyebrow">System Settings</span>
			<h1 class="hris-page-title">Sector / Industry</h1>
			<p class="hris-page-subtitle">Manage the list of sectors and industries grouped by region and coverage.</p>
		</div>

		<q-form ref="vForm" @submit="onSubmit">
			<div class="row q-col-gutter-lg">
				<div class="col-12 col-md-4">
					<div class="hris-form-section">
						<h2 class="hris-form-section-title">Add / Edit Sector</h2>
						<div class="hris-form-row">
							<div class="hris-form-field">
								<q-select outlined dense color="green" v-model="region" option-value="id" option-label="region_no" :rules="[formRules.required]" :options="regionOptions" label="Region" emit-value map-options @input="getCoverage"></q-select>
							</div>
						</div>
						<div class="hris-form-row">
							<div class="hris-form-field">
								<q-select outlined dense color="green" v-model="provcover" option-value="id" option-label="coverage" :rules="[formRules.required]" :options="coverageOtions" label="Coverage" emit-value map-options></q-select>
							</div>
						</div>
						<div class="hris-form-row">
							<div class="hris-form-field">
								<q-input outlined dense color="green" v-model="sector" label="Sector/Industry" :rules="[formRules.required]" class="caps"></q-input>
							</div>
						</div>
						<div class="hris-form-actions">
							<q-btn unelevated class="hris-q-primary full-width" type="submit" label="Save"></q-btn>
						</div>
					</div>
				</div>
				<div class="col-12 col-md-8">
					<div class="hris-panel">
						<h2 class="hris-panel-title">Sector List</h2>
						<q-table
							flat
							:data="sectorData"
							:columns="columns"
							row-key="id"
							:pagination.sync="pagination"
						>
							<template v-slot:body="props">
								<q-tr slot="body" :props="props" @click="selectedRow(props)" style="cursor: pointer;">
									<q-td key="id" :props="props">{{ props.row.counter }}</q-td>
									<q-td key="region" :props="props">{{ props.row.region }}</q-td>
									<q-td key="coverage" :props="props">{{ props.row.coverage }}</q-td>
									<q-td key="sector" :props="props">{{ props.row.sector }}</q-td>
									<q-td key="action" :props="props">
										<q-btn flat round dense class="hris-q-ghost" @click="removeRow(props)">
											<i class="fas fa-trash"></i>
											<q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]">
												<strong>Remove</strong>
											</q-tooltip>
										</q-btn>
									</q-td>
								</q-tr>
							</template>
							<template v-slot:no-data="">
								<div class="hris-empty full-width">
									No results found.
								</div>
							</template>
						</q-table>
					</div>
				</div>
			</div>
		</q-form>

		<q-dialog v-model="spinner" persistent>
			<div class="hris-loading" style="background: #fff; border-radius: 14px; padding: 32px 44px;">
				<q-spinner color="green" size="40px"></q-spinner>
			</div>
		</q-dialog>

		<q-dialog v-model="deleted" persistent>
			<div class="hris-modal">
				<div class="hris-modal-header">
					<h2 class="hris-modal-title">Confirm Deletion</h2>
				</div>
				<div class="hris-modal-body">
					This record will be permanently deleted.
				</div>
				<div class="hris-modal-footer">
					<q-btn flat label="Cancel" class="hris-q-ghost" v-close-popup></q-btn>
					<q-btn unelevated label="Delete" class="hris-q-primary" v-close-popup @click="deletionConfirmation"></q-btn>
				</div>
			</div>
		</q-dialog>
	</div>
</div>
</template>

<script>
import axios from 'axios';
import mixins from '../../mixins';


export default {
	data () {
		return {
			tempID:0,
			spinner:false,
			deleted:false,
			sectorData:[],
			regionOptions:[],
			region:null,
			provcover:null,
			sector:null,
			coverageOtions:[],
			type:'account',
			columns: [
			{ name: 'id', align: 'center', label: 'ID', field: 'id', sortable: true },
			{ name: 'region', align: 'center', label: 'Region', field: 'region', sortable: true },
			{ name: 'coverage', align: 'center', label: 'Coverage', field: 'coverage' , sortable: true},
			{ name: 'sector', align: 'center', label: 'Sector', field: 'sector' , sortable: true},
			{ name: 'action', align: 'center', label: 'Action', field: '', sortable: true },
			],
			pagination: {
				rowsPerPage: 20
			},
		}
	},

	created(){
		
		this.displayRegions()
		this.displayData()
	},

	methods: {

		onSubmit : function(){
			this.spinner = true;
			let formData = new FormData();

			formData.append("regionID", this.region);
			formData.append("coverageID", this.provcover);
			formData.append("sector", this.sector);
			formData.append("tempID", this.tempID);

			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post('/admin/sector',formData)
			.then((res) => {
				this.displayData()
				this.tempID = 0
				this.region = '',
				this.provcover = '',
				this.sector = '',
				this.spinner = false;
				this.$refs.vForm.reset()
			});
		},

		displayData: function() {
			axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
			.get(`/admin/sectors`)
			.then((res) => {
				this.sectorData = res.data.sectors;
				setTimeout(() => {
					this.spinner = false
				},500)
			})

		},

		displayRegions: function() {
			axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
			.get(`/admin/regions`)
			.then((res) => {
				//console.log(res.data.data)
				this.regionOptions = res.data.data;
				setTimeout(() => {
					this.spinner = false
				},500)
			})
		},

		getCoverage:function(){
			axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
			.get(`/admin/region/sector/${this.region}`)
			.then((res) => {
				this.coverage = []
				this.coverageOtions = res.data.data;
				//console.log(this.coverageOtions)
				setTimeout(() => {
					this.spinner = false
				},500)
			})
		},

		selectedRow:function(obj){
			
			this.tempID = obj.row.id
			this.region = obj.row.regionID
			this.sector = obj.row.sector
			this.provcover = obj.row.coverageID
			this.getCoverage()
		},

		removeRow:function(obj){
			console.log(obj.row.id)
			this.deleted = true
			this.tempID = obj.row.id
		},

		deletionConfirmation:function(){
			this.spinner = true;
			let formData = new FormData();
			formData.append("tempID", this.tempID);
			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post('/admin/sector/delete',formData)
			.then((res) => {
				this.tempID = 0
				this.displayData()
			});
		}

	}
}
</script>
<style>
.caps {
	text-transform: uppercase
}
</style>